import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import { ConciliationStatus } from '../../types';
import {
  dashboardStatusYesterdaySelector,
  dashboardStatusCurrentMonthSelector,
  dashboardStatusLastMonthSelector,
  dashboardCountrySelectedSelector,
} from '../../state';
import StatusCard from '../StatusCard';

const DashboardStatusCards = () => {
  const countrySelected = useSelector(dashboardCountrySelectedSelector);

  const yesterdayResource = useSelector(dashboardStatusYesterdaySelector);
  const currentMonthResource = useSelector(dashboardStatusCurrentMonthSelector);
  const lastMonthResource = useSelector(dashboardStatusLastMonthSelector);
  const items: {
    title: string;
    data: ConciliationStatus[];
    loading: boolean;
  }[] = [
    {
      title: 'dashboard.time_tabs.yesterday',
      data: yesterdayResource?.data || [],
      loading: yesterdayResource.loading,
    },
    {
      title: 'dashboard.time_tabs.current_month',
      data: currentMonthResource?.data || [],
      loading: currentMonthResource.loading,
    },
    {
      title: 'dashboard.time_tabs.last_month',
      data: lastMonthResource?.data || [],
      loading: lastMonthResource.loading,
    },
  ];

  return countrySelected ? (
    <Grid container spacing={3} data-guide="dashboard-status-cards">
      {items.map(({ title, data, loading }) => (
        <Grid key={title} item xs={12} lg={4}>
          <StatusCard
            key={title}
            countrySelected={countrySelected}
            title={title}
            data={data}
            loading={loading}
          />
        </Grid>
      ))}
    </Grid>
  ) : null;
};

export default DashboardStatusCards;
